import Comparison from "@components/Dashboard/Comparison";
import Consolidation from "@components/Dashboard/Consolidation";
import { data, useLoaderData } from "react-router";

import OnboardingActionsSection from "@/components/Onboarding/OnboardingActionsSection";
import OnboardingContent from "@/components/Onboarding/OnboardingContent";
import OnboardingResourcesSection from "@/components/Onboarding/OnboardingResourcesSection";
import type {
  Comparison as TComparison,
  ConsolidatedReview as TConsolidatedReview,
} from "@/types";

export async function loader() {
  const consolidatedReviewResponse = await fetch(
    "/api/client/reviews/consolidated"
  );

  if (consolidatedReviewResponse.status !== 200) {
    throw data("Failed to load consolidated review", {
      status: consolidatedReviewResponse.status,
    });
  }

  const { data: consolidatedReview } =
    (await consolidatedReviewResponse.json()) as {
      data: TConsolidatedReview | null;
    };

  if (!consolidatedReview) {
    return {
      consolidatedReview,
      comparisonData: null,
    };
  }

  const comparisonResponse = await fetch("/api/client/dashboard/comparison/");

  if (comparisonResponse.status !== 200) {
    throw data("Failed to load comparison", {
      status: comparisonResponse.status,
    });
  }

  // null when the company is not eligible to the comparison
  const { data: comparisonData } = (await comparisonResponse.json()) as {
    data: TComparison | null;
  };

  return {
    consolidatedReview,
    comparisonData,
  };
}

function DashboardOverview() {
  const { consolidatedReview, comparisonData } = useLoaderData<typeof loader>();

  if (!consolidatedReview) {
    return <OnboardingContent />;
  }

  return (
    <div className="gap-y-md flex flex-col">
      <OnboardingActionsSection />
      <Consolidation consolidatedReview={consolidatedReview} />
      {comparisonData ? <Comparison comparisonData={comparisonData} /> : null}
      <OnboardingResourcesSection />
    </div>
  );
}

export default DashboardOverview;
